<app-widget-container>
  <form>
    <mat-action-list>
      <mat-list-item
        (click)="useNewObjectPageFC.enabled && useNewObjectPageToggle.toggle()"
        (keydown)="null"
        [disabled]="useNewMainMenuFC.value"
      >
        <span matListItemTitle class="feature-title">
          {{ 'TRANS__FEATURE_FLAGS_WIDGET__NEW_OBJECT_PAGE_TITLE' | translate }}
        </span>

        <span
          matListItemLine
          class="feature-description"
        >
          {{ 'TRANS__FEATURE_FLAGS_WIDGET__NEW_OBJECT_PAGE_DESCRIPTION' | translate }}
        </span>

        <mat-slide-toggle
          (click)="$event.stopPropagation()"
          (keydown)="null"
          matListItemMeta
          #useNewObjectPageToggle
          [formControl]="useNewObjectPageFC"
        ></mat-slide-toggle>
      </mat-list-item>

      <mat-list-item
        (click)="useNewFilterMenuFC.enabled && useNewFilterMenu.toggle()"
        (keydown)="null"
        [disabled]="useNewMainMenuFC.value"
      >
        <span
          matListItemTitle
          class="feature-title"
        >
          {{ 'TRANS__FEATURE_FLAGS_WIDGET__NEW_FILTER_MENU_TITLE' | translate }}
        </span>

        <span
          matListItemLine
          class="feature-description"
        >
          {{ 'TRANS__FEATURE_FLAGS_WIDGET__NEW_FILTER_MENU_DESCRIPTION' | translate }}
        </span>

        <mat-slide-toggle
          (click)="$event.stopPropagation()"
          (keydown)="null"
          matListItemMeta
          #useNewFilterMenu
          [formControl]="useNewFilterMenuFC"
        ></mat-slide-toggle>
      </mat-list-item>

      <mat-list-item
        (click)="toggleNewLayout()"
        (keydown)="null"
      >
        <span
          matListItemTitle
          class="feature-title"
        >
          {{ 'TRANS__FEATURE_FLAGS_WIDGET__NEW_MAIN_MENU_TITLE' | translate }}
        </span>

        <span
          matListItemLine
          class="feature-description"
        >
          {{ 'TRANS__FEATURE_FLAGS_WIDGET__NEW_MAIN_MENU_DESCRIPTION' | translate }}
        </span>

        <mat-slide-toggle
          (click)="toggleNewLayout()"
          (keydown)="null"
          matListItemMeta
          [formControl]="useNewMainMenuFC"
        ></mat-slide-toggle>
      </mat-list-item>
    </mat-action-list>
  </form>
</app-widget-container>
